import { HTMLAttributes } from 'react'

import Button from '@/components/base/button-more'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import MediaParallax from '../base/media-parallax'
import { WPLink, WPMedia } from '@/types'

export type PushBannerProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    pretitle: string
    title: string
    paragraph: string
    media: WPMedia
    link: WPLink
  }>

const PushBanner = ({ pretitle, title, paragraph, media, link, ...props }: PushBannerProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-[3rem]">
          <div className="col-span-2 md:col-span-3 lg:col-span-8 xl:col-span-9">
            {media ? (
              <MediaParallax className="relative aspect-[350/380] overflow-hidden lg:aspect-[920/600]">
                <span className="flex size-full">
                  <Media className="object-cover" {...media} />
                </span>
              </MediaParallax>
            ) : null}
          </div>

          <div className="col-span-2 md:col-span-3 lg:col-span-4 xl:col-span-3">
            <div className="grid gap-y-[3rem] xl:gap-y-[4.8rem]">
              <div className="grid gap-y-[3rem]">
                {pretitle ? (
                  <Typography variant="upper-small" component="h3" className="font-bold uppercase">
                    {pretitle}
                  </Typography>
                ) : null}

                {title ? (
                  <Typography variant="main-title-default" component="h2">
                    {title}
                  </Typography>
                ) : null}

                {paragraph ? (
                  <Typography
                    paragraph
                    className="font-helvetica text-[1.6rem] leading-[150%] md:text-[2rem]"
                  >
                    {paragraph}
                  </Typography>
                ) : null}
              </div>

              {link && link.url ? (
                <div className="flex">
                  <Button href={link?.url} target={link?.target}>
                    {link?.title}
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default PushBanner
